const HOVER_COMMIT_DELAY_MS = 120;

class GvodeCategoryProductMenu extends HTMLElement {
  #hoverTimer;
  #initialized = false;

  connectedCallback() {
    if (this.#initialized) return;

    this.triggers = [...this.querySelectorAll('[data-gvode-category-trigger]')];
    this.panels = [...this.querySelectorAll('[data-gvode-product-panel]')];

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('pointerenter', () => {
        clearTimeout(this.#hoverTimer);
        this.#hoverTimer = setTimeout(
          () => this.activate(trigger.dataset.panelId),
          HOVER_COMMIT_DELAY_MS,
        );
      });
      trigger.addEventListener('pointerleave', () => clearTimeout(this.#hoverTimer));
      trigger.addEventListener('focus', () => this.activate(trigger.dataset.panelId));
      trigger.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    const initiallyExpanded =
      this.triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true') ?? this.triggers[0];
    if (initiallyExpanded) this.activate(initiallyExpanded.dataset.panelId);

    this.#initialized = true;
  }

  disconnectedCallback() {
    clearTimeout(this.#hoverTimer);
  }

  activate(panelId, { focus = false } = {}) {
    this.triggers.forEach((trigger) => {
      const active = trigger.dataset.panelId === panelId;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-expanded', String(active));
      if (active && focus) trigger.focus();
    });

    this.panels.forEach((panel) => {
      const active = panel.id === panelId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  onKeydown(event, currentIndex) {
    const nextIndex = GvodeCategoryProductMenu.nextIndex(currentIndex, event.key, this.triggers.length);
    if (nextIndex === null) return;

    event.preventDefault();
    const nextTrigger = this.triggers[nextIndex];
    this.activate(nextTrigger.dataset.panelId, { focus: true });
  }

  static nextIndex(current, key, count) {
    if (count < 1) return null;
    if (key === 'ArrowDown') return (current + 1) % count;
    if (key === 'ArrowUp') return (current - 1 + count) % count;
    if (key === 'Home') return 0;
    if (key === 'End') return count - 1;
    return null;
  }
}

if (!customElements.get('gvode-category-product-menu')) {
  customElements.define('gvode-category-product-menu', GvodeCategoryProductMenu);
}
